import styled, { css } from 'styled-components';

export const ShortWrapper = styled.div.attrs<{ className?: string }>(() => ({
  className: `grid-item`,
}))`
  border-radius: 4px;
  overflow: hidden;
  ${props =>
    props.theme.isMobile
      ? css`
          margin: 8px 4px;
        `
      : css`
          width: 319px;
          margin: 16px 0;
        `}
`;

export const LongWrapper = styled.div.attrs<{ className?: string }>(() => ({
  className: `grid-item`,
}))`
  border-radius: 4px;
  padding: 16px;
  overflow: hidden;
  ${props =>
    props.theme.isMobile
      ? css`
          margin: 8px 4px;
          background-color: white;
        `
      : css`
          width: 100%;
          margin: 16px 0;
        `}
`;
